import { Input } from '@/components/input'
import { Label } from '@/components/label'
import { Switch } from '@/components/switch'
import { TableHead, TableRow } from '@/components/table'

import { useMarketFilter, useSetMarketFilterIncludeDeleted, useSetMarketFilterText } from '@/state/marketFilter'

interface Props {
    clientCode: string
}

export default function MarketTableFilter({ clientCode }: Props) {
    const marketFilter = useMarketFilter(clientCode)
    const setFilterText = useSetMarketFilterText(clientCode)
    const setIncludeDeleted = useSetMarketFilterIncludeDeleted(clientCode)

    return (
        <TableRow>
            <TableHead colSpan={5}>
                <div className="flex items-center gap-4">
                    <Label className="m-0">Filter</Label>
                    <Input
                        className="h-8 w-65"
                        value={marketFilter.filterText}
                        onChange={e => setFilterText(e.target.value)}
                    />
                </div>
            </TableHead>
            <TableHead>
                <div className="flex items-center justify-end gap-4">
                    <Switch checked={marketFilter.includeDeleted} onCheckedChange={setIncludeDeleted} />
                    <Label className="m-0">Include deleted</Label>
                </div>
            </TableHead>
        </TableRow>
    )
}
